import type { ReactNode } from 'react';

import { Select } from 'antd';

import { SelectStyled } from './styled';

type Props = {
  data:
    | {
        value: string | number;
        label: string | ReactNode;
      }[]
    | undefined;
  placeholder: string;
  isLoading?: boolean;
  mode?: 'multiple' | 'tags';
};

const { Option } = Select;

export function SelectCustomize({ data, placeholder, isLoading, mode = undefined }: Props) {
  return (
    <SelectStyled
      mode={mode}
      placeholder={placeholder}
      optionFilterProp="children"
      showSearch
      loading={isLoading}
      maxTagCount="responsive"
      filterSort={(optionA, optionB) =>
        (optionA.children ?? '')
          ?.toLowerCase()
          .localeCompare((optionB.children ?? '')?.toLowerCase())
      }
    >
      {data &&
        data.map((item) => (
          <Option value={item.value} key={item.value}>
            {item.label}
          </Option>
        ))}
    </SelectStyled>
  );
}
